import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import { loadUserFromStorage } from "./redux/slices/authSlice.js";

// Load token into Redux before App renders
store.dispatch(loadUserFromStorage());

// Handle GitLab SPA redirect
const redirectPath = new URLSearchParams(window.location.search).get(
  "redirect"
);
if (redirectPath) {
  window.history.replaceState(null, "", redirectPath);
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
